/** 手机布局：工具栏允许换行，手写弹窗限制动态可视高度，避免窄屏和键盘弹出后遮住业务操作。 */
import React, { useMemo } from "react";
import { useApp } from "../context/AppContext";
import BranchPerformance from "../components/BranchPerformance";
import SalesLeaderboard from "../components/SalesLeaderboard";
import BriefingCard from "../components/cockpit/BriefingCard";
import CockpitReportCard from "../components/cockpit/CockpitReportCard";
import CollectionsCharts from "../components/cockpit/CollectionsCharts";
import CollectThisMonth from "../components/cockpit/CollectThisMonth";
import { Gauge } from "lucide-react";

const TEAM_REGION = { team_norcal: "norcal", team_1: "la", team_2: "la", team_3: "sd", team_sd: "sd" };
const REGION_NAME = { la: ["洛杉矶", "Los Angeles"], norcal: ["北加州", "NorCal"], sd: ["圣地亚哥", "San Diego"] };

export default function OpsCockpit() {
  const { lang, user, projects } = useApp();
  const zh = lang === "zh";
  const isVp = user.role === "sales_vp";
  const region = !isVp && user.region && user.region !== "hq" ? user.region : null;
  const scoped = useMemo(() => (region ? projects.filter((p) => TEAM_REGION[p.team] === region) : projects), [projects, region]);
  const regionLabel = region ? (REGION_NAME[region] || [region, region])[zh ? 0 : 1] : null;
  return (
    <div className="space-y-6" data-testid="ops-cockpit" data-scope={region || "all"}>
      <div className="flex-wrap md:flex-nowrap flex items-start gap-3">
        <div className="h-11 w-11 rounded-xl bg-brand-500/10 flex items-center justify-center shrink-0"><Gauge className="h-6 w-6 text-brand-500" /></div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900" data-testid="ops-cockpit-title">{zh ? "运营总监驾驶舱" : "Operations Cockpit"}</h1>
          <p className="text-sm text-slate-500" data-testid="ops-cockpit-scope">
            {region
              ? (zh ? `${user.name} · 销售经理 · 仅显示 ${regionLabel} 分公司数据` : `${user.name} · Sales Manager · ${regionLabel} only`)
              : (zh ? `${user.name} · ${isVp ? "销售副总裁" : "销售经理"} · 全公司三分公司数据` : `${user.name} · ${isVp ? "VP Sales" : "Sales Manager"} · all branches`)}
          </p>
        </div>
      </div>
      <BranchPerformance />
      <SalesLeaderboard projects={scoped} />
      <CockpitReportCard region={region} />
      <BriefingCard />
      <CollectionsCharts projects={scoped} />
      <CollectThisMonth projects={scoped} />
    </div>
  );
}
